import { ALLOWED_LABEL_LAYOUTS, ALLOWED_SELECT_WIDTHS, sanitizeAllowedString, sanitizeBindable, sanitizeBoolean, sanitizeBoundValue, sanitizeFormatSpec, sanitizeFormattableBindable, sanitizeString } from './helpers';
function sanitizeSelectOptions(raw) {
  if (!Array.isArray(raw)) return undefined;
  const options = raw.filter(o => typeof o === 'object' && o !== null).map(o => ({
    label: sanitizeFormattableBindable(o.label, sanitizeString),
    value: sanitizeString(o.value)
  })).filter(o => o.label !== undefined && o.value !== undefined);
  return options.length > 0 ? options : undefined;
}
export function sanitizeSelect(el) {
  const value = sanitizeBoundValue(el.value);
  if (!value) return null;
  const options = sanitizeBindable(el.options, sanitizeSelectOptions);
  if (!options) return null;
  return {
    type: 'Select',
    value,
    options,
    label: sanitizeBindable(el.label, sanitizeString),
    labelLayout: sanitizeBindable(el.labelLayout, v => sanitizeAllowedString(v, ALLOWED_LABEL_LAYOUTS)),
    width: sanitizeBindable(el.width, v => sanitizeAllowedString(v, ALLOWED_SELECT_WIDTHS)),
    optionFormat: sanitizeFormatSpec(el.optionFormat),
    placeholder: sanitizeBindable(el.placeholder, sanitizeString),
    required: sanitizeBindable(el.required, sanitizeBoolean),
    disabled: sanitizeBindable(el.disabled, sanitizeBoolean)
  };
}